// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4226": "1ffec92b489d","494": "4077578422d4","6863": "454c9f289029","8153": "89799faeb38d","8357": "dd422574e14d",}[chunkId] + ".css"
}